import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=c98bf8c8&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=c98bf8c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports